import gql from 'graphql-tag';

export const GET_ALL_BENEFIT_LIST = gql`
query(
    $golf_group_code: String
    $golf_code: String
    $limit_rows: Int
    $begin_row: Int
){
    GetBenefitsListByPlanMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        limit_rows: $limit_rows
        begin_row: $begin_row
    ){
        BenefitsMasterList{
            golf_code
            golf_group_code
            benefit_cd
            benefit_name
            benefit_detail
            valid_flag
        }
    count
    }
}
`;

export const REGISTER_BENEFIT_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $benefit_name: String
    $benefit_detail: String
    $valid_flag: Int
  ){
    RegisterBenefitMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        benefit_name: $benefit_name
        benefit_detail: $benefit_detail
        valid_flag: $valid_flag
  ){
    result
  }
}
`;

export const UPDATE_BENEFIT_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $benefit_name: String
    $benefit_cd: String
    $benefit_detail: String
    $valid_flag: Int
  ){
    UpdateBenefitMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        benefit_name: $benefit_name
        benefit_cd: $benefit_cd
        benefit_detail: $benefit_detail
        valid_flag: $valid_flag
  ){
    result
  }
}
`;
